export const defaultVideoState = {
  live: true,
  url: "",
  date: "",
  description: "",
  duration: "",
  link: "",
};
